<template>
  <span :title="date">{{ timeString }}</span>
</template>

<script>
// const util = require('../util');

export default {
  props: {
    date: {
      type: [String, Date],
      required: true
    },
    locale: {
      type: String,
      default: '' // fallback to browser language
    },
  },
  data() {
    return {
      timeString: '',
      secondsElapsed: 0,
      intervalId: null
    }
  },
  watch: {
    date() {
      this.updateTime();
    },
  },
  mounted() {
    this.updateTime()
    this.startInterval()
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    startInterval() {
      this.intervalId = setInterval(() => {
        this.secondsElapsed += this.getIntervalStep()
        this.updateTime()

        // Switch to 60s interval after 60s have passed
        if (this.secondsElapsed === 60) {
          clearInterval(this.intervalId)
          this.startInterval()
        }
      }, this.getIntervalStep() * 1000)
    },
    getIntervalStep() {
      return this.secondsElapsed < 60 ? 5 : 60
    },
    updateTime() {
      this.timeString = this.date && this.getTimeSince(this.date) || '-';
    },
    getTimeSince(dateInput) {
      if(this.date === undefined) return '-';
      const now = new Date()
      const date = new Date(dateInput)
      const seconds = Math.floor((now - date) / 1000)

      const intervals = [
        { unit: 'year', seconds: 31536000 },
        { unit: 'month', seconds: 2592000 },
        { unit: 'day', seconds: 86400 },
        { unit: 'hour', seconds: 3600 },
        { unit: 'minute', seconds: 60 },
        { unit: 'second', seconds: 1 }
      ]

      const rtf = new Intl.RelativeTimeFormat(
        this.locale || navigator.language,
        { numeric: 'auto' }
      )

      for (const interval of intervals) {
        const count = Math.floor(seconds / interval.seconds)
        if (count >= 1) {
          return rtf.format(-count, interval.unit) // Negative = past
        }
      }

      return rtf.format(0, 'second')
    }
  }
}
</script>
